import React from 'react';

import { DateTime } from 'luxon';
import { Row, Col, Form } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { Field } from 'formik';

import { DatePickerField } from 'components/Forms';

interface IDateTimePickerProps {
  prefix?: string;
  minDate?: DateTime;
  maxDate?: DateTime;
  dateLabelKey?: string;
  containerClassName?: string;
  disabled?: boolean;
  required?: boolean;
}

const DateTimePicker = ({
  prefix,
  minDate,
  maxDate,
  dateLabelKey,
  containerClassName,
  disabled = false,
  required = false
}: IDateTimePickerProps) => {
  const intl = useIntl();

  return (
    <Row className={containerClassName}>
      <Col>
        <Form.Group className="form-group">
          <DatePickerField
            label={intl.formatMessage({ id: dateLabelKey || 'dateKey' })}
            dataTestId={`${prefix}-date`}
            name={`${prefix}Date`}
            className="w-100"
            wrapperClassName="w-100"
            minDate={minDate?.toJSDate()}
            maxDate={maxDate?.toJSDate()}
            popperClassName="z-100"
            disabled={disabled}
            required={required}
          />
        </Form.Group>
      </Col>
      <Col>
        <Form.Group className="form-group">
          <Form.Label>{`${intl.formatMessage({ id: 'timeKey' })}${
            required ? ' *' : ''
          }`}</Form.Label>
          <Field
            className="form-control"
            data-test={`${prefix}-time`}
            type="time"
            name={`${prefix}Time`}
            disabled={disabled}
          />
        </Form.Group>
      </Col>
    </Row>
  );
};

export default DateTimePicker;
